import { scrollToIdInContainer } from './tabUtils'
const getLocationHash = () => {
  return location.hash
}

const tabListSelector = '.cmp-tabs__tablist'
const runSetActiveTabAfterDomUpdate = () => {
  // Core tabs updates active classes after click handlers; defer to next tick.
  setTimeout(() => setActiveTab(), 0)
}

const setActiveTab = () => {
  const activeTabWithMediaGallery = document.querySelector('.cmp-tabs__tabpanel--active .mediagallery:not(.custom-event-fired)')

  if (activeTabWithMediaGallery) {
    const changeTabEvent = new CustomEvent('changetab')
    window.dispatchEvent(changeTabEvent)
    activeTabWithMediaGallery.classList.add('custom-event-fired')
  }

  const TabsVertical = document.querySelector('.cmp-tabs.cmp-tabs-vertical')
  const TabsHorizontal = document.querySelector('.cmp-tabs:not(.cmp-tabs-vertical)')
  const header = document.querySelector('.cmp-header')

  if (TabsVertical) {
    const currentHash = window.location.hash
    setTimeout(() => {
      history.replaceState(null, null, ' ')

      const headerHeight = header ? header.offsetHeight : 0

      let tabPosition
      if (TabsVertical?.querySelector(currentHash)) {
        tabPosition = TabsVertical.getBoundingClientRect().top + window.scrollY
      } else if (TabsHorizontal && TabsHorizontal.querySelector(currentHash)) {
        tabPosition = TabsHorizontal.getBoundingClientRect().top + window.scrollY
      }

      if (tabPosition !== undefined) {
        window.scrollTo({
          top: tabPosition - headerHeight - 10,
          behavior: 'smooth',
        })
      }

      setTimeout(() => history.replaceState(null, null, currentHash), 150)
    }, 200)
  }
}

const hasHorizontalScroll = element => element.scrollWidth > element.clientWidth

document.addEventListener('DOMContentLoaded', () => {
  const tabs = Array.from(document.querySelectorAll('.cmp-tabs__tab'))
  const locationHash = getLocationHash()
  if (locationHash) {
    const checkInterval = setInterval(() => {
      const header = document.querySelector('.cmp-header')
      const anchorNavigation = document.querySelector('.cmp-anchor-navigation')
      if (anchorNavigation) {
        const headerHeight = header ? header.offsetHeight : 0
        const anchorNavigationHeight = anchorNavigation ? anchorNavigation.offsetHeight : 0
        const elementPosition = document.querySelector(locationHash).getBoundingClientRect().top
        const deductScrollBy = (headerHeight + anchorNavigationHeight) * 1.6
        const offsetPosition = elementPosition + window.scrollY - deductScrollBy
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })
        clearInterval(checkInterval) // Stop checking once the class is found
      }
    }, 1500)
  }
  const TabsVerticalList = document.querySelectorAll('.cmp-tabs.cmp-tabs-vertical')
  TabsVerticalList.forEach(TabsVertical => {
    const ActiveTabHeading = TabsVertical?.querySelector('.cmp-tab-active--heading')
    const TabsContainer = TabsVertical?.querySelector(tabListSelector)

    if (TabsContainer) {
      const FirstTab = TabsContainer.querySelector('.cmp-tabs__tab')
      FirstTab.appendChild(document.createElement('span'))
      const tabsExpanded = 'cmp-tabs__tab--expanded'

      const ActiveTabText = TabsContainer.querySelector('.cmp-tabs__tab--active').innerHTML
      ActiveTabHeading.innerHTML = ActiveTabText

      ActiveTabHeading.addEventListener('click', () => {
        TabsContainer.classList.add(tabsExpanded)
      })

      const FirstTabSpan = FirstTab.querySelector('span')
      FirstTabSpan.addEventListener('click', e => {
        TabsContainer.classList.remove(tabsExpanded)
        e.stopPropagation()
      })

      if (hasHorizontalScroll(TabsContainer)) {
        TabsContainer.classList.add('cmp-tabs__tablist--has-scroll')
      }
    }
  })

  if (tabs.length) {
    tabs.forEach(el => {
      const elementId = `#${el.id}`
      el.addEventListener('click', e => {
        e.stopPropagation()

        const TabElgrandparent = e.currentTarget.closest('.cmp-tabs-vertical')
        if (TabElgrandparent) {
          const tabHeadingSelected = TabElgrandparent.querySelector('.cmp-tab-active--heading')
          const tabContainer = TabElgrandparent.querySelector(tabListSelector)
          if (tabHeadingSelected && tabContainer) {
            tabHeadingSelected.innerHTML = el.innerHTML
            tabContainer.classList.remove('cmp-tabs__tab--expanded')
          }
        }

        const isVerticalTab = el.closest('.cmp-tabs-vertical') !== null
        el.dataset.tabType = isVerticalTab ? 'vertical' : 'horizontal'

        runSetActiveTabAfterDomUpdate()
      })

      if (locationHash && elementId === locationHash) {
        runSetActiveTabAfterDomUpdate()
      }
    })
  }

  const scrollableDiv = document.querySelectorAll('.cmp-tabs__tabpanel--scroll .cmp-tabs__tabpanel')
  let lastGesture = false

  function markGesture() {
    lastGesture = true
  }

  document.addEventListener('wheel', markGesture, { passive: true })
  document.addEventListener('touchstart', markGesture, { passive: true })
  document.addEventListener(
    'keydown',
    e => {
      if ([' ', 'Spacebar', 'PageDown', 'ArrowDown', 'End'].includes(e.key)) {
        markGesture()
      }
    },
    { passive: true },
  )

  scrollableDiv.forEach(item => {
    item.addEventListener(
      'scroll',
      e => {
        const el = e.currentTarget
        const threshold = 1
        const reachedBottom = Math.ceil(el.scrollTop + el.clientHeight) >= Math.floor(el.scrollHeight) - threshold
        if (!lastGesture) {
          return // no recent user gesture
        }
        if (reachedBottom) {
          const elTabpanelNextElementSibling = el.nextElementSibling
          if (elTabpanelNextElementSibling) {
            const closestTabList = el.closest('.cmp-tabs__tabpanel--scroll')
            const closestTabListActiveTab = closestTabList.querySelector('.cmp-tabs__tab--active')
            const closestTabListActiveTabNextElementSibling = closestTabListActiveTab.nextElementSibling
            const closestTabListActiveTabNextElementSiblingId = closestTabListActiveTabNextElementSibling.id
            const currentHash = `#${closestTabListActiveTabNextElementSiblingId}`
            history.replaceState(null, null, currentHash)

            el.scrollTop = 0

            closestTabListActiveTabNextElementSibling.classList.add('cmp-tabs__tab--active')
            closestTabListActiveTab.classList.remove('cmp-tabs__tab--active')

            elTabpanelNextElementSibling.classList.add('cmp-tabs__tabpanel--active')
            el.classList.remove('cmp-tabs__tabpanel--active')

            const container = closestTabList.querySelector(tabListSelector)
            scrollToIdInContainer(container, closestTabListActiveTabNextElementSiblingId, { axis: 'x', align: 'start' })
            lastGesture = false
          }
        }
      },
      { passive: true },
    )
  })
})
